import { AutomationModalActionType, AutomationTrigger } from '../enums';
import { QuestionType } from 'utils/constants/roles';
import { yesNoAnswerOptions } from '../data';
import { GetFormDefaultValuesReturnValue } from '../types';
import { JobViewQuestion, JobViewQuestionSetItem } from 'features/TabbedJobView/QuestionsTab/types';

export const getAnswerOptions = (questionType: QuestionType) => {
  switch (questionType) {
    case QuestionType.yes_no:
      return yesNoAnswerOptions;
    default:
      throw new Error('Unexpected question type');
  }
};

export const getActionType = () => {
  return [{ id: AutomationModalActionType.UPDATE_STATUS, label: 'Update status' }];
};

export const getFormDefaultValues = (roleId: number): GetFormDefaultValuesReturnValue => ({
  automations: [
    {
      role_id: roleId,
      order: 0,
      trigger: {
        trigger_type: AutomationTrigger.QUESTION_ANSWER,
        question_id: null,
        question_type: null,
        expected_answer: 'Yes',
      },
      action: {
        action_type: AutomationModalActionType.UPDATE_STATUS,
        new_status_id: undefined,
      },
    },
  ],
});

export const transformOptions = (
  options: (JobViewQuestionSetItem | JobViewQuestion)[]
): JobViewQuestion[] => {
  if (!options || !Array.isArray(options)) {
    return [];
  }

  const finalOptions: JobViewQuestion[] = [];

  for (const option of options) {
    if ('is_qs' in option && option.is_qs) {
      for (const customQuestion of option.custom_questions) {
        if (customQuestion.question_type === QuestionType.yes_no) {
          finalOptions.push(customQuestion);
        }
      }
    } else if ('question_type' in option && option.question_type === QuestionType.yes_no) {
      finalOptions.push(option);
    }
  }

  return finalOptions;
};
